import React, { useEffect, useRef, useState } from "react";
import LoadingIcon from "../../elements/loading/spinner.component.jsx";
import StandardCheckbox from "../../elements/buttons/standardCheckbox.button.jsx";
import StandardInstruction from "../../elements/text/standardInstruction.component.jsx";

export default function CampusSelection(props) {
  const initMount = useRef(true);
  const [loading, setLoading] = useState(false);
  const [selectedCampusKeys, setSelectedCampusKey] = useState(
    props.selectedCampuses
  );
  const campusSelectContainer = useRef(null);

  const toggleSelectCampusKey = (key) => {
    if (loading) return;

    if (selectedCampusKeys.includes(key)) {
      if (selectedCampusKeys.length > 1) {
        setSelectedCampusKey(selectedCampusKeys.filter((s) => s !== key));
      } else {
        setLoading(false);
      }
    } else {
      setSelectedCampusKey(selectedCampusKeys.concat(key));
    }
  };

  useEffect(() => {
    if (initMount.current) return;
    setLoading(true);
  }, [selectedCampusKeys]);

  useEffect(() => {
    if (!loading) return;
    if (!selectedCampusKeys.length) {
      campusSelectContainer.current.classList.add("shake");
      setTimeout(() => {
        campusSelectContainer.current.classList.remove("shake");
      }, 500);
      return;
    }
    props.loadCampuses(selectedCampusKeys);
  }, [loading]);

  useEffect(() => {
    if (initMount.current) return;
    setLoading(false);
  }, [props.serverDataLoaded]);

  useEffect(() => {
    initMount.current = false;
  }, []);

  return (
    <div className="d-flex flex-column">
      <StandardInstruction className={"mb-4"}>{props.text}</StandardInstruction>
      <div ref={campusSelectContainer}>
        {props.campuses.map((c) => (
          <div
            key={c.campusKey}
            onClick={() => toggleSelectCampusKey(c.campusKey)}
            className="general-margin-bottom-large d-flex justify-content-between"
          >
            <span>{c.name}</span>
            <StandardCheckbox
              checked={selectedCampusKeys.includes(c.campusKey)}
            />
          </div>
        ))}
        <LoadingIcon loading={loading} fullscreen={false} />
      </div>
    </div>
  );
}
